import { cn } from '../../utils/cn'
import { makeCtaAnalyticsClickHandler, useCtaAnalytics } from '../../utils/cta-analytics'
import { AtLink, AtLinkProps } from '../at-link'
import { getAtLinkButtonVariant } from './at-link-button.props'

export type AtLinkButtonVariants = 'button-primary-dark' | 'button-primary-light'

export interface AtLinkButtonProps extends AtLinkProps {
  variant?: AtLinkButtonVariants
  parentName?: string
}

export const AtLinkButton = ({
  title,
  actionTarget,
  target,
  variant = 'button-primary-dark',
  parentName = 'not available',
  className,
}: AtLinkButtonProps) => {
  const { logClick } = useCtaAnalytics()
  return (
    <AtLink
      hasExternalStyles={true}
      className={cn('inline-flex items-center justify-center', getAtLinkButtonVariant(variant), className)}
      title={title?.toUpperCase()}
      actionTarget={actionTarget}
      target={target}
      onClick={makeCtaAnalyticsClickHandler(logClick, {
        text: title ?? '',
        href: actionTarget ?? '',
        style: 'text link',
        component: parentName,
      })}
    ></AtLink>
  )
}
